var render, staticRenderFns
import script from "./WxTextarea.vue?vue&type=script&lang=js"
export * from "./WxTextarea.vue?vue&type=script&lang=js"
import style0 from "./WxTextarea.vue?vue&type=style&index=0&id=05a4de14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a4de14",
  null
  
)

export default component.exports